export function gciPageView(pageTitle) {
    try {
      if (gciAnalytics) {
        gciAnalytics_data['content-title'] = document.title;
        gciAnalytics_data['content-headline'] = pageTitle;
        gciAnalytics_data['page-full-url'] = window.location;
        gciAnalytics_data['content-name'] = window.location.pathname;
        gciAnalytics.view(gciAnalytics_data);
      }
    }
	catch(error) { ; }
}


// WEBPACK FOOTER //
// ./src/lib/analytics.js